import { useState, useEffect } from 'react'
import { useDisclosure, useMediaQuery, useViewportSize, useWindowScroll } from '@mantine/hooks';

import { Drawer, Stack, Button, Image, Title, Space, Text, UnstyledButton, Center, Loader, Modal } from '@mantine/core';
import Offers from './components/Offers';
import ReactConfetti from 'react-confetti';

function App() {

  const googleOptimizeExperimentId = "CzdDzXP_Rci-2kaQ1XmFoA"
  const [experimentVariant, setExperimentVariant] = useState('')
  const [count, setCount] = useState(0)
  const [chosenProduct, setChosenProduct] = useState(null)
  const [loadingOffer, setLoadingOffer] = useState(false)
  const [justGoToCart, setJustGoToCart] = useState(false)
  
  const [opened, { open, close }] = useDisclosure(false);

  const isMobile = useMediaQuery('(max-width: 600px)');
  const isLargeMobile = useMediaQuery('(max-width: 900px)');

  const isDevelopment = () => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
  }

  const { height, width } = useViewportSize()
  const [scroll, scrollTo] = useWindowScroll();
    
  const handleAddToCart = (product, mobile) => {
    setChosenProduct(product)
    setLoadingOffer(true)
    if (!isDevelopment()) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Promotion',
        eventAction: 'Accept - ' + product.shortTitle + ' - ' + (mobile ? 'Mobile' : "Desktop"),
        eventLabel: `Yoki/Horudo BS Popup - ${googleOptimizeExperimentId} - ${experimentVariant}`
      });
    } 
    setTimeout(() => {
      window.location = "https://aikidosteel.com/cart/add/" + product.variantId
    }, 1000)
    
  }

  const handleJustGoToCart = (mobile) => {
    setJustGoToCart(true)
    setLoadingOffer(false)
    if (!isDevelopment()) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Promotion',
        eventAction: 'Reject - ' + (mobile ? 'Mobile' : "Desktop"),
        eventLabel: `Yoki/Horudo BS Popup - ${googleOptimizeExperimentId} - ${experimentVariant}`
      });
    }
    setTimeout(() => {
      window.location = "https://aikidosteel.com/cart"
    }, 1000)

  }

  const getCookieIHReact = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

  const addAddToCartEventListeners = () => {

    console.log('hello2')
      
    // Trigger popup on Add to Cart button 1
    document.querySelectorAll('[data-add-to-cart]')[0].addEventListener('click', open);
    
    // Trigger popup on Add to Cart button 2
    document.querySelectorAll('[data-add-to-cart]')[1].addEventListener('click', open);
    
      
  }
  
 
  const [offerList, setOfferList] = useState([
    {
      imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Yoki___Niku_cutout.png?v=1762932829",
      title: "Yoki Knife Holder and Niku Shears",
      shortTitle: "Gift",
      link: "https://aikidosteel.com/products/yoki-knife-holder-niku-shears-bundle",
      variantId: 47026258772226,
      offerPrice: 0,
      regularPrice: 149.90
    }
  ])

  const [offerTitle, setOfferTitle] = useState('Complete Your Knife Set!')

  useEffect(()=> {
    const tempExperimentVariant = window.google_optimize ? window.google_optimize.get(googleOptimizeExperimentId) : "n/a"
    setExperimentVariant(tempExperimentVariant)

    //base case: Yoki (No Best-Seller Badge), Horudo (No Best-Seller Badge)
    if(tempExperimentVariant === "0") {}

    //1st experimental case: Horudo (No Best-Seller Badge), Yoki (No Best-Seller Badge)
    if(tempExperimentVariant === "1") {

      setOfferList([
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Horudo_cut_out_web.png?v=1667885502",
          title: "Horudo Magnetic Knife Holder",
          shortTitle: "Horudo",
          link: "https://aikidosteel.com/collections/kitchen-accessories/products/horudo-acacia-magnetic-knife-holder",
          variantId: 32326432489543,
          offerPrice: 25.99,
          regularPrice: 129.95
        },
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/V2_cutout_web.png?v=1668489497",
          title: "Yoki Knife Holder",
          shortTitle: "Yoki",
          link: "https://aikidosteel.com/products/aikido-knife-holder",
          variantId: 32090905149511,
          offerPrice: 0,
          regularPrice: 69.95
        }
      ])

    }

    //2nd experimental case: Yoki (Best-Seller Badge), Horudo (No Best-Seller Badge)
    if(tempExperimentVariant === "2") {

      setOfferList([
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Best_Seller_Yoki_0.3x.png?v=1693201123",
          title: "Yoki Knife Holder",
          shortTitle: "Yoki",
          link: "https://aikidosteel.com/products/aikido-knife-holder",
          variantId: 32090905149511,
          offerPrice: 0,
          regularPrice: 69.95
        },
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Horudo_cut_out_web.png?v=1667885502",
          title: "Horudo Magnetic Knife Holder",
          shortTitle: "Horudo",
          link: "https://aikidosteel.com/collections/kitchen-accessories/products/horudo-acacia-magnetic-knife-holder",
          variantId: 32326432489543,
          offerPrice: 25.99,
          regularPrice: 129.95
        }
      ])

    }

    //3rd experimental case: Yoki (No Best-Seller Badge), Horudo (Best-Seller Badge)
    if(tempExperimentVariant === "3") {

      setOfferList([
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/V2_cutout_web.png?v=1668489497",
          title: "Yoki Knife Holder",
          shortTitle: "Yoki",
          link: "https://aikidosteel.com/products/aikido-knife-holder",
          variantId: 32090905149511,
          offerPrice: 0,
          regularPrice: 69.95
        },
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Best_Seller_Horudo_0.15x.png?v=1693201123",
          title: "Horudo Magnetic Knife Holder",
          shortTitle: "Horudo",
          link: "https://aikidosteel.com/collections/kitchen-accessories/products/horudo-acacia-magnetic-knife-holder",
          variantId: 32326432489543,
          offerPrice: 25.99,
          regularPrice: 129.95
        }
      ])

    }

    //4th experimental case: Horudo (Best-Seller Badge), Yoki (No Best-Seller Badge)
    if(tempExperimentVariant === "4") {

      setOfferList([
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Best_Seller_Horudo_0.15x.png?v=1693201123",
          title: "Horudo Magnetic Knife Holder",
          shortTitle: "Horudo",
          link: "https://aikidosteel.com/collections/kitchen-accessories/products/horudo-acacia-magnetic-knife-holder",
          variantId: 32326432489543,
          offerPrice: 25.99,
          regularPrice: 129.95
        },{
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/V2_cutout_web.png?v=1668489497",
          title: "Yoki Knife Holder",
          shortTitle: "Yoki",
          link: "https://aikidosteel.com/products/aikido-knife-holder",
          variantId: 32090905149511,
          offerPrice: 0,
          regularPrice: 69.95
        }
      ])

    }

    //5th experimental case: Horudo (No Best-Seller Badge), Yoki (Best-Seller Badge)
    if(tempExperimentVariant === "5") {

      setOfferList([
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Horudo_cut_out_web.png?v=1667885502",
          title: "Horudo Magnetic Knife Holder",
          shortTitle: "Horudo",
          link: "https://aikidosteel.com/collections/kitchen-accessories/products/horudo-acacia-magnetic-knife-holder",
          variantId: 32326432489543,
          offerPrice: 25.99,
          regularPrice: 129.95
        },
        {
          imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Best_Seller_Yoki_0.3x.png?v=1693201123",
          title: "Yoki Knife Holder",
          shortTitle: "Yoki",
          link: "https://aikidosteel.com/products/aikido-knife-holder",
          variantId: 32090905149511,
          offerPrice: 0,
          regularPrice: 69.95
        }
      ])

    }

  }, [window.google_optimize])

  useEffect(()=> {
    if(opened && !isDevelopment()) {
      window.ga('send', {hitType: 'event',
        eventCategory: 'Promotion',
        eventAction: 'Show - ' + (isLargeMobile ? 'Mobile' : "Desktop"),
        eventLabel: `Yoki/Horudo BS Popup - ${googleOptimizeExperimentId} - ${experimentVariant}`
      });
    }
  }, [opened])

  useEffect(() => {

    if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'production') && !(getCookieIHReact('ref') === '92639642EBF20241119EM1') && !(getCookieIHReact('ref') === '649452EBF20241116EM1') && !(getCookieIHReact('ref') === '8346781VIPTGPREP20231104EM1' && window.meta.product.id === 8105390702850) && !(getCookieIHReact('ref') === '967634BF20231123EM1') && !(getCookieIHReact('ref') === '2567966HOL620251225EM1') && !(getCookieIHReact('ref') === '496MOM20230423EM1') && !(getCookieIHReact('ref') === '395823FD20240605EM1') && !(getCookieIHReact('ref') === '529647HOLID12023EM1')) {
      console.log('hello')

      let retries = 0;
      const maxRetries = 20; // stop after 4 seconds (20 * 200ms)

      const tryAddListeners = () => {
        const buttons = document.querySelectorAll('[data-add-to-cart]');
        if (buttons.length >= 2) {
          console.log('hello2');
          console.log('retries needed:', retries)
          buttons[0].addEventListener('click', open);
          buttons[1].addEventListener('click', open);
        } else if (retries < maxRetries) {
          retries += 1;
          setTimeout(tryAddListeners, 200);
        } else {
          console.warn('Add to Cart buttons not found after maximum retries.');
        }
      };

      tryAddListeners();

      console.log('hello4')
      // setTimeout(window.addEventListener('load', function() {
      //   console.log('hello5')
      //   addAddToCartEventListeners()

      // }), 3000)

      }

  }, [])

  return (
    <div>
      {!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? <Button onClick={open}>Add to Cart</Button> : null}
      {
        opened
      ?
        (isMobile ?
        <ReactConfetti style={{zIndex: 100000}} confettiSource={{x: 0 , y: 0, w: width, h: height + scroll.y}} height={height + scroll.y} numberOfPieces={75} gravity={0.4} recycle={false} tweenDuration={150}/>
        :
        <ReactConfetti style={{zIndex: 100000}} confettiSource={{x: 0 , y: 0, w: width, h: height + scroll.y}} height={height + scroll.y} numberOfPieces={150} gravity={0.15} recycle={false} tweenDuration={150}/>
        )
      :
        null
      } 
      <Drawer style={{position: "absolute", zIndex: 10000}} transitionProps={{ duration: 750 }} title={loadingOffer || justGoToCart ? null : <Title align="center" order={isMobile ? 3 : 2} style={{fontFamily: "Oswald", letterSpacing: "1.6px", color: "#ffe27b", fontWeight: 500, fontSize: "1.175rem"}}>EXCLUSIVE OFFER</Title>} styles={{title: {margin: "auto", paddingLeft: "18px"}, header: {background: "black", color: "white"}}} size={isMobile ? "100%" : "550px"} position={"top"} opened={opened} onClose={close} overlayProps={{ opacity: 0.5, blur: 4 }} withCloseButton={!(loadingOffer || justGoToCart)}>
      
        {!loadingOffer && !justGoToCart ?
          <>
            <Title mt={20} align="center" style={{fontFamily: "Roboto", letterSpacing: "-0.195px", fontSize: "1.525rem", lineHeight: "1.25"}}>{offerTitle}</Title>
            <Space h={"xl"}></Space>
            <Offers googleOptimizeExperimentId={googleOptimizeExperimentId} experimentVariant={experimentVariant} offerList={offerList} handleAddToCart={handleAddToCart}></Offers>
            <Center>
              <UnstyledButton onClick={() => {handleJustGoToCart(isLargeMobile)}} mt={isMobile ? 20 : 30} style={{textDecoration: "underline", fontSize: "0.9rem"}}>NO THANKS, GO TO MY CART</UnstyledButton>
            </Center>
            
          </>
        :
          loadingOffer && !justGoToCart ?
            <>
              <Center h={400}>
                <Stack align={"center"}>
                  <Image height={150} mx="auto" fit="contain" src={chosenProduct.imageSrc}></Image>
                  <Title align="center" order={1} style={{fontFamily: "Bebas Neue"}}>Adding your offer</Title>
                  <Loader variant='dots'></Loader>
                </Stack>
                
              </Center>
            </>
          :
            <>
              <Center h={400}>
                <Stack align={"center"}>
                
                  <Title align="center" order={1} style={{fontFamily: "Bebas Neue"}}>Loading your cart</Title>
                  <Loader variant='dots'></Loader>
                  
                </Stack>
                
              </Center>
            </>
        }
      </Drawer>
    </div>
  )
}

export default App
